import React from 'react';
import dayjs from 'dayjs';

import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  Legend
} from 'recharts';

import { useTranslation } from "react-i18next";

const CourbeService = (props) => {

  const [t] = useTranslation('common');

  return (
      <React.Fragment>
        <ResponsiveContainer width="100%" height={350}>
          <ScatterChart width={730} height={250}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            data={props.realtimeData}>
            <XAxis
              type="number"
              dataKey="time"
              name='time'
              domain={[1556438400000, 1556521200000]}
              tickFormatter={(unixTime) => dayjs(unixTime).format('HH:mm:ss')}
              ticks={[
                1556438400000,
                1556442000000, 1556445600000, 1556449200000, 1556452800000,
                1556456400000, 1556460000000, 1556463600000, 1556467200000,
                1556470800000, 1556474400000, 1556478000000, 1556481600000,
                1556485200000, 1556488800000, 1556492400000, 1556496000000,
                1556499600000, 1556503200000, 1556506800000, 1556510400000,
                1556514000000, 1556517600000, 1556521200000
              ]}
            />
            <YAxis dataKey="veh" name='véhicules' domain={[0, Math.max(...props.plannedData.map(o => o.veh))]}
              label={{ value: props.groupe, angle: -90, position: 'insideLeft' }} />
            <ZAxis dataKey="z" range={[10]} />
            <Legend formatter={(value, entry, index) =>
              <span style={{ color: "black" }} className="text-color-class">{value}</span>
            } />
            <Scatter name={t('plancurve.rt')} data={props.realtimeData} fill={props.color} />
            <Scatter name={t('plancurve.plan')} data={props.plannedData} fill="grey" />
          </ScatterChart>
        </ResponsiveContainer>
      </React.Fragment >
    );
  
}

export default CourbeService;